import axios from "../../utils/axios";

async function start(data) {
  return await axios.post(`/single/shifts`, data);
}

async function fetchCurrent() {
  return await axios.get(`/single/shifts/current`);
}

async function fetchList(date) {
  return await axios.get(`/single/shifts`, { params: { date } });
}

async function fetch(shiftId) {
  return await axios.get(`/single/shifts/${shiftId}`);
}

async function addMovement(shiftId, data) {
  return await axios.post(`/single/shifts/${shiftId}/movements`, data);
}

async function close(shiftId, data) {
  return await axios.post(`/single/shifts/${shiftId}/close`, data);
}

const shiftService = {
  start,
  fetchCurrent,
  fetchList,
  fetch,
  addMovement,
  close,
};
export default shiftService;
